import * as types from '../constants';

export const initDoorlockTileListState = () => ({
  type: types.INIT_DOORLOCK_TILE_LIST_STATE,
});

export const setDoorlockList = doorlockList => ({
  type: types.SET_DOORLOCK_TILE_LIST,
  payload: doorlockList
});

export const setCurrentPageNumber = currentPageNumber => ({
  type: types.SET_DOORLOCK_TILE_LIST_CURRENT_PAGE_NUMBER,
  payload: currentPageNumber
});

export const setPaginationItem = paginationItem => ({
  type: types.SET_DOORLOCK_TILE_PAGINATION_ITEM,
  payload: paginationItem
});

export const setFilterItem = filterItem => ({
  type: types.SET_DOORLOCK_TILE_FILTER_ITEM,
  payload: filterItem
});